module.exports = __webpack_public_path__ + "static/img/it.68030e43.png";